
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[degree]/landing",
      function () {
        return require("private-next-pages/[degree]/landing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[degree]/landing"])
      });
    }
  